export enum SupporterFeedbackLanguageSource {
  /** Sent with donor feedback form */
  DonorFeedback = 'donor-feedback',
  /** Browser */
  Browser = 'browser',
  /** Default is always english */
  Default = 'default',
}
